/**
 * List of available settings in the settings collection.
 *
 * **Do not remove or change the order of this enum as it is used as the table key**
 */
export const enum SettingsMap {
  CenterLocked = 'center-locked',
  CenterMuted = 'center-muted',
  CenterPosition = 'center-position',
  ToastPosition = 'toast-position',
  ToastDuration = 'toast-duration',
}

/**
 * Shape of the internal settings stored in the database.
 */
export interface StoredSetting {
  id: SettingsMap;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  value: any;
}
